export function setupLinking(cb: (url: string) => void) {
  window.addEventListener("popstate", () => cb(location.href));
  setTimeout(() => cb(location.href), 0);
}
